import { getAtoms } from './getAtoms'

export default getAtoms
